module.exports = __webpack_public_path__ + "img/Pellets-kosten.5878af7.webp";